import { render, staticRenderFns } from "./publishService.vue?vue&type=template&id=01a1ca28&scoped=true&"
import script from "./publishService.vue?vue&type=script&lang=js&"
export * from "./publishService.vue?vue&type=script&lang=js&"
import style0 from "./publishService.vue?vue&type=style&index=0&id=01a1ca28&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a1ca28",
  null
  
)

export default component.exports